import CustomPlanImage from 'images/dashboard/plans/custom.svg';
import DisabledPlanImage from 'images/dashboard/plans/disabled.svg';
import EssentialPlanImage from 'images/dashboard/plans/essential.svg';
import GrowthPlanImage from 'images/dashboard/plans/growth.svg';
import SandboxPlanImage from 'images/dashboard/plans/sandbox.svg';
import StarterPlanImage from 'images/dashboard/plans/starter.svg';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export interface OrganizationPlanAttributes {
  'able-to-request-plan-changes-in-dashboard': boolean;
  'archives-blueprints': boolean;
  'display-icon-key': OrganizationPlanIconKey;
  'display-name': string;
  'ends-in-days': number | null;
  key: OrganizationPlanKey;
  'product-feature-access-is-locked': boolean;
}

export interface OrganizationPlanRelationships {}

export type OrganizationPlan = ApiResource<
  OrganizationPlanAttributes,
  OrganizationPlanRelationships,
  ApiModel.OrganizationPlan
>;

export enum OrganizationPlanKey {
  Bugcrowd = 'bugcrowd',
  Churned = 'churned',
  Essential = 'essential',
  Growth = 'growth',
  Internal = 'internal',
  Managed = 'managed',
  Partner = 'partner',
  Restricted = 'restricted',
  SelfServeSandbox = 'self_serve_sandbox',
  Starter = 'starter',
  StarterPenguin = 'starter_penguin',
  TrialEssential = 'trial_essential',
  TrialGrowth = 'trial_growth',
  TrialSalesProspect = 'trial_sales_prospect',
}

export interface AvailableOrganizationPlan {
  'archives-blueprints': boolean;
  'display-icon-key': OrganizationPlanIconKey;
  'display-name': string;
  key: OrganizationPlanKey;
  rank: number;
}

// Note: Keep synced with DisplayIconKey in `app/models/organization_plan.rb`
export enum OrganizationPlanIconKey {
  Sandbox = 'sandbox_plan_image',
  Starter = 'starter_plan_image',
  Essential = 'essential_plan_image',
  Growth = 'growth_plan_image',
  Custom = 'custom_plan_image',
  Disabled = 'disabled_plan_image',
}

export const organizationPlanIconsMap: Record<OrganizationPlanIconKey, React.ReactNode> = {
  [OrganizationPlanIconKey.Sandbox]: <SandboxPlanImage />,
  [OrganizationPlanIconKey.Starter]: <StarterPlanImage />,
  [OrganizationPlanIconKey.Essential]: <EssentialPlanImage />,
  [OrganizationPlanIconKey.Growth]: <GrowthPlanImage />,
  [OrganizationPlanIconKey.Custom]: <CustomPlanImage />,
  [OrganizationPlanIconKey.Disabled]: <DisabledPlanImage />,
};
